import { Icon, Shadow, Text, VStack } from '@genial/components';
import { BoxRadius, Color, Spacing, Typography } from '@genial/design-tokens';
import { useNavigation } from '@react-navigation/native';
import React from 'react';
import { Pressable } from 'react-native';

import { SignedInNavigationScreenNavigationProp } from '../../../../../../../routes/types';
import { moduleName } from '../../../constants';

export const InvestmentStrategyCard: React.FC = () => {
  const navigation = useNavigation<SignedInNavigationScreenNavigationProp>();
  const handlePress = () => {
    navigation.navigate('AppDrawer', {
      screen: 'HomeInvestmentStrategyMobile',
    });
  };

  return (
    <Pressable onPress={handlePress}>
      <Shadow level={1} borderRadius={BoxRadius.xs} p={Spacing['inline.xxxs']}>
        <VStack space={Spacing['stack.nano']} width="100%">
          <Icon name="Analytics" size="sm" color={Color['brand.tertiary.principal']} />
          <Text width="100%" fontSize={Typography['fontsize.md']}>
            {moduleName}
          </Text>
        </VStack>
      </Shadow>
    </Pressable>
  );
};
